import React from 'react';

const Select_on_off = ({ checked, onChange, tabIndex = 0, id }) => {
  const handleClick = () => {
    onChange({ target: { checked: !checked } });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'y' || e.key === 'Y') {
      onChange({ target: { checked: true } });
    } else if (e.key === 'n' || e.key === 'N') {
      onChange({ target: { checked: false } });
    } else if (e.key === 'Enter') {
      onChange({ target: { checked: !checked } });
    }
  };

  return (
    <div
      id={id}
      tabIndex={tabIndex}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      style={{
        width: '50px',
        height: '24px',
        borderRadius: '20px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        padding: '1px 2px',
       backgroundColor: checked ? '#33b873ff' : '#f87171',
        transition: 'background-color 0.2s ease',
      }}
    >
      <div
        style={{
          width: '17px',
          height: '17px',
          borderRadius: '50%',
              backgroundColor:'#fff',
          transform: checked ? 'translateX(35px)' : 'translateX(0px)',
          transition: 'transform 0.2s ease',
          boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
        }}
      ></div>
    </div>
  );
};

export default Select_on_off;
